import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setFullHeight } from '../../actions/uiActions';
import { RedirectAs404 } from '../Error404';
import TopicTree from '../TopicTree';


class TopicTreeTitle extends Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  componentDidMount () {
    const { actions } = this.props;
    actions.setFullHeight(false);
  }

  render () {
    const { match, name, shortDescription, longDescription, topics } = this.props;
    return (
      <Switch>
        <Route exact path={`${match.url}/:topicSlug?/:issueSlug?/:mediaIndex?`} render={props => {
          let activeTopic = null;
          let activeIssue = null;
          let activeMedia = null;
          const { topicSlug, issueSlug, mediaIndex } = props.match.params;

          if (typeof topicSlug !== 'undefined') {
            activeTopic = topics.find(topic => topic.slug === topicSlug);
            if (!activeTopic) {
              return <RedirectAs404 />;
            }
          }

          if (typeof issueSlug !== 'undefined') {
            activeIssue = activeTopic.subtopics.find(issue => issue.slug === issueSlug);
            if (!activeIssue) {
              return <RedirectAs404 />;
            }
          }

          if (typeof mediaIndex !== 'undefined') {
            const idx = parseInt(mediaIndex, 10) - 1;
            activeMedia = activeIssue.videos[idx];
            if (!activeMedia) {
              return <RedirectAs404 />;
            }
          }

          return (
            <div className="title-wrapper">
              <div className="title-alt-container" style={{ maxWidth: 'unset' }}>
                <header className="mb-2">
                  <h4 className="heading-alt text-uppercase mb-1">{name}</h4>
                  <div className="body-copy muted" dangerouslySetInnerHTML={{ __html: longDescription }} />
                </header>
                <TopicTree
                  titleProps={{ name, shortDescription, longDescription }}
                  baseUrl={match.url}
                  topics={topics}
                  activeTopic={activeTopic}
                  activeIssue={activeIssue}
                  activeMedia={activeMedia}
                />
              </div>
            </div>
          );
        }} />
        <Route component={RedirectAs404} />
      </Switch>
    );
  }
}

TopicTreeTitle.propTypes = {
  actions: PropTypes.object,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ setFullHeight }, dispatch),
});

export default withRouter(connect(null, mapDispatchToProps)(TopicTreeTitle));



// WEBPACK FOOTER //
// ./src/components/Title/TopicTreeTitle.js